import numeral from 'numeral'

/**
 * numeral provides an interface for setting a global zero format and a global null format,
 * but it does not provide an interface for setting a one-time zero format or null format
 * (this features has been requested, though: https://github.com/adamwdraper/Numeral-js/issues/257).
 * This utility provides such an interface.
 */
const formatNumberWithNumeral = (val, placeholder, format = '$0,0') => {
  const originalZeroFormat = numeral(0).format(format)
  const originalNullFormat = numeral(null).format(format)
  if (typeof placeholder === 'string') {
    numeral.zeroFormat(placeholder)
    numeral.nullFormat(placeholder)
  }
  const result = numeral(val).format(format)
  numeral.zeroFormat(originalZeroFormat)
  numeral.nullFormat(originalNullFormat)
  return result
}

const NUMERAL_FORMAT_WITH_CENTS = '$0,0.00'

export const formatNumberWithCents = (val, placeholder) =>
  formatNumberWithNumeral(val, placeholder, NUMERAL_FORMAT_WITH_CENTS)
